/**
 * Servicio para gestión del módulo de Posventa
 * Incluye: Pólizas, Carnets, Encuestas Producto, Reportes Garantía
 * Formatos: AMX-PVTA-FR-01, AMX-PVTA-FR-03, AMX-PVTA-FR-04, AMX-PVTA-FR-05, AMX-PVTA-FR-06
 */

import api from './api.js';

class PosventaService {
  // =====================================================
  // PÓLIZAS DE GARANTÍA (AMX-PVTA-FR-03)
  // =====================================================

  async listarPolizas(params = {}) {
    const cleanParams = this.limpiarParams(params);
    return await api.get('/posventa/polizas', cleanParams);
  }

  async obtenerPoliza(id) {
    return await api.get(`/posventa/polizas/${id}`);
  }

  async obtenerPolizaPorNumSerie(numSerie) {
    return await api.get(`/posventa/polizas/tractor/${numSerie}`);
  }

  async crearPoliza(data) {
    return await api.post('/posventa/polizas', data);
  }

  async actualizarPoliza(id, data) {
    return await api.put(`/posventa/polizas/${id}`, data);
  }

  async eliminarPoliza(id) {
    return await api.delete(`/posventa/polizas/${id}`);
  }

  // =====================================================
  // CARNETS DE SERVICIOS (AMX-PVTA-FR-01/05)
  // =====================================================

  async listarCarnets(params = {}) {
    const cleanParams = this.limpiarParams(params);
    return await api.get('/posventa/carnets', cleanParams);
  }

  async obtenerCarnet(id) {
    return await api.get(`/posventa/carnets/${id}`);
  }

  async crearCarnet(data) {
    return await api.post('/posventa/carnets', data);
  }

  async actualizarCarnet(id, data) {
    return await api.put(`/posventa/carnets/${id}`, data);
  }

  async eliminarCarnet(id) {
    return await api.delete(`/posventa/carnets/${id}`);
  }

  async registrarServicio(carnetId, data) {
    return await api.post(`/posventa/carnets/${carnetId}/servicios`, data);
  }

  // =====================================================
  // ENCUESTAS DE SATISFACCIÓN DEL PRODUCTO (AMX-PVTA-FR-04)
  // =====================================================

  async listarEncuestasProducto(params = {}) {
    const cleanParams = this.limpiarParams(params);
    return await api.get('/posventa/encuestas-producto', cleanParams);
  }

  async obtenerEncuestaProducto(id) {
    return await api.get(`/posventa/encuestas-producto/${id}`);
  }

  async crearEncuestaProducto(data) {
    return await api.post('/posventa/encuestas-producto', data);
  }

  async actualizarEncuestaProducto(id, data) {
    return await api.put(`/posventa/encuestas-producto/${id}`, data);
  }

  async completarEncuestaProducto(id) {
    return await api.post(`/posventa/encuestas-producto/${id}/completar`);
  }

  async eliminarEncuestaProducto(id) {
    return await api.delete(`/posventa/encuestas-producto/${id}`);
  }

  async estadisticasEncuestasProducto() {
    return await api.get('/posventa/encuestas-producto/estadisticas');
  }

  // =====================================================
  // REPORTES DE GARANTÍA (AMX-PVTA-FR-06)
  // =====================================================

  async listarReportesGarantia(params = {}) {
    const cleanParams = this.limpiarParams(params);
    return await api.get('/posventa/reportes-garantia', cleanParams);
  }

  async obtenerReporteGarantia(id) {
    return await api.get(`/posventa/reportes-garantia/${id}`);
  }

  async crearReporteGarantia(data) {
    return await api.post('/posventa/reportes-garantia', data);
  }

  async completarReporteGarantia(id) {
    return await api.post(`/posventa/reportes-garantia/${id}/completar`);
  }

  async actualizarReporteGarantia(id, data) {
    return await api.put(`/posventa/reportes-garantia/${id}`, data);
  }

  async eliminarReporteGarantia(id) {
    return await api.delete(`/posventa/reportes-garantia/${id}`);
  }

  async diagnosticarReporteGarantia(id, data) {
    return await api.patch(`/posventa/reportes-garantia/${id}/diagnostico`, data);
  }

  async cerrarReporteGarantia(id, data) {
    return await api.patch(`/posventa/reportes-garantia/${id}/cerrar`, data);
  }

  async estadisticasReportesGarantia() {
    return await api.get('/posventa/reportes-garantia/estadisticas');
  }

  // =====================================================
  // ESTADÍSTICAS GENERALES
  // =====================================================

  async estadisticasGenerales() {
    return await api.get('/posventa/estadisticas');
  }

  // Alias para compatibilidad con vistas
  async obtenerEstadisticas() {
    return await this.estadisticasGenerales();
  }

  // =====================================================
  // UTILIDADES
  // =====================================================

  limpiarParams(params) {
    const cleanParams = {};
    Object.keys(params).forEach(key => {
      if (params[key] !== '' && params[key] !== null && params[key] !== undefined) {
        cleanParams[key] = params[key];
      }
    });
    return cleanParams;
  }
}

export default new PosventaService();
